
import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MoonLoader from "./MoonLoader";
import { useTheme } from "@mui/material/styles";

const PageLoader = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "background.default",
        width: "100%",
        height: "100%",
      }}
    >
      <MoonLoader size={60} color={theme.palette.primary.main} />
      <Typography
        variant="h6"
        sx={{
          mt: 2,
          color: "text.secondary",
          fontWeight: 500,
          animation: "pulse 1.5s infinite ease-in-out",
          "@keyframes pulse": {
            "0%": { opacity: 0.6 },
            "50%": { opacity: 1 },
            "100%": { opacity: 0.6 },
          },
        }}
      >
        Loading...
      </Typography>
    </Box>
  );
};

export default PageLoader;
